import axios from 'axios'
import { decrypt } from './crypto'
import Cookies from 'js-cookie' // 引入Cookies插件，用来存储token

axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'

const fetch: any = axios.create({
  baseURL: '',
  timeout: 60 * 1000 // 设置超时时间
})
/** 请求拦截 */
fetch.interceptors.request.use(
  (config: any) => {
    const token = Cookies.get('token') || ''
    config.headers['Authorization'] = token

    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

/** 响应拦截 */
fetch.interceptors.response.use(
  (res: any) => {
    if (res.config?.method === 'get') {
      return new Promise((resolve, reject) => {
        switch (res.data.error_code) {
          case undefined:
            resolve(res.data.result)
            break
          case '000000':
            resolve(res.data.result)
            break
          default:
            reject(res.data)
        }
      })
    } else {
      let data = res.data

      if (res.config.crypto) data = JSON.parse(decrypt(res.data, 'z8uil4vz' + res.config.url?.split('&v=1.0&t=')[1].slice(-8)))
      else {
        try {
          data = JSON.parse(JSON.parse(res.data.replace('data:', '')))
        } catch (e) {
          data = {
            error_code: 'error',
            result: '数据解析失败，请联系管理员'
          }
        }
      }
      return new Promise((resolve, reject) => {
        if (res.config.resolveDataData && data.data) {
          resolve(data.data)
          return
        }

        switch (data.error_code) {
          case undefined:
            resolve(data.result)
            break
          case '000000':
            resolve(data.result)
            break
          default:
            reject(data)
        }
      })
    }
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

export default fetch
